import React, { useState } from 'react';
import './../../entrydoor.css';

const BrickmouldType = ({ value, onChange, label = 'Type' }) => {
    const [selectedBrickmouldType, setSelectedBrickmouldType] = useState(value || "");

    const handleBrickmouldTypeChange = (e) => {
        const newValue = e.target.value;
        setSelectedBrickmouldType(newValue); // Update local state
        onChange(newValue); // Call onChange prop with the new value
    };

    return (
        <div className="a-container">
            <label  style={{ display: "none" }} htmlFor="BrickmouldType">{label}</label>
            <select style={{ display: "none" }}
                id="BrickmouldType"
                value={selectedBrickmouldType}
                onChange={handleBrickmouldTypeChange}
            >
              <option value="" disabled hidden>Select an option</option>  
              <option value='Standard'>{selectedBrickmouldType === 'Standard' ? 'Standard ✔' : 'Standard'}</option>
              <option value='ContemporaryFlat'>{selectedBrickmouldType === 'ContemporaryFlat' ? 'Contemporary Flat ✔' : 'Contemporary Flat'}</option>
            </select>
        </div>
    );
};

export default BrickmouldType;
